if (document.readyState !== 'loading') {
  initFormValidation();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    initFormValidation();
  });
}

function initFormValidation() {
  // Retrieve referrer URL from localStorage and add to form field
  const referrerUrl = localStorage.getItem('referrerUrl');
  const referrerUrlInput = document.getElementById('referrer-url');
  if (referrerUrl && referrerUrlInput) {
    referrerUrlInput.value = JSON.parse(referrerUrl).value;
  }

  // Retrieve entry point URL from localStorage and add to form field
  const entryPointUrl = localStorage.getItem('entryPointUrl');
  const entryPointUrlInput = document.getElementById('entry-point-url');
  if (entryPointUrl && entryPointUrlInput) {
    entryPointUrlInput.value = JSON.parse(entryPointUrl).value;
  }

  // Ignore blur validation checks on sidebar login form
  var sidebarForm = document.querySelector(
    '.sidebar-form .c-form-row.Password'
  );
  if (sidebarForm) {
    var sidebarPassword = document.querySelector(
      '.sidebar-form .c-form-row.Password'
    );
    if (sidebarPassword) {
      sidebarPassword.classList.add('ignore-blur');
    }
  }

  var form = document.querySelector('#dynamicForm form');
  if (typeof form != 'undefined' && form != null) {
    passwordHelpText(form);

    form.addEventListener(
      'blur',
      function (e) {
        if (e.target.required) {
          if (e.target.type === 'text') {
            validateTextInput(e.target);
          } else if (e.target.type === 'email') {
            validateEmailInput(e.target);
          } else if (e.target.type === 'tel') {
            validateTelInput(e.target);
          } else if (e.target.type === 'password') {
            validatePasswordInput(e.target);
          } else if (e.target.tagName === 'TEXTAREA') {
            validateTextareaInput(e.target);
          }
        }
      },
      true
    );

    form.addEventListener(
      'change',
      function (e) {
        if (e.target.required) {
          if (e.target.tagName === 'SELECT') {
            validateSelectInput(e.target);
          }
        }
      },
      true
    );

    var loginButton = document.querySelector('#Login');
    if (typeof loginButton != 'undefined' && loginButton != null) {
      loginButton.addEventListener('click', function (e) {
        e.preventDefault();
        validateForm(e);
      });
    }

    var submitButton = document.querySelector('#btnSubmit');
    if (typeof submitButton != 'undefined' && submitButton != null) {
      document
        .querySelector('#btnSubmit')
        .addEventListener('click', function (e) {
          e.preventDefault();
          validateForm(e);
          window.VWO = window.VWO || [];
          var formInstance = e.target.form;
          if (
            document.querySelectorAll('.required.c-input-error').length >= 1
          ) {
            window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 0]); // VWO form submission error
            document.querySelector('.required.c-input-error').scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          } else {
            e.target.disabled = true;
            gtag('event', 'form_submit', {
              origin_url: window.location.href,
              form_id: formInstance.id,
            });
            _paq.push([
              'trackEvent',
              'Form submit',
              formInstance.id,
              window.location.href,
            ]);
            _paq.push([
              'trackEvent',
              'Form submission',
              formInstance.id,
              window.location.href,
            ]);
            window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 1]); // VWO form submission success
            var enhancedConversionFormClasses = [
              'EmailSales',
              'QuoteRequest',
              'DemoRequest',
              'RegisterProfile',
            ];
            enhancedConversionFormClasses.forEach(function (formClass) {
              if (formInstance.parentNode.classList.contains(formClass)) {
                localStorage.setItem(
                  'first_name',
                  formInstance.querySelector('input#FirstName').value
                );
                localStorage.setItem(
                  'last_name',
                  formInstance.querySelector('input#LastName').value
                );
                localStorage.setItem(
                  'email',
                  formInstance.querySelector('input#EmailAddress').value
                );
                localStorage.setItem(
                  'phone_number',
                  formInstance.querySelector('input#Telephone').value
                );
                localStorage.setItem(
                  'city',
                  formInstance.querySelector('input#City').value
                );
                localStorage.setItem(
                  'country',
                  formInstance.querySelector('select#Country option:checked')
                    .text
                );
              }
            });
            submitWithRecaptcha(); // Recaptcha v3 submit
          }
        });
    }
  }
}

function validateForm(e) {
  var formFields = Array.from(e.target.form.elements);
  formFields.forEach(function (field) {
    if (field.required) {
      var formInput = field.closest('.c-form-row, .c-form__field');
      if (formInput) {
        if (formInput.classList.contains('u-hidden')) {
          formInput.classList.add('c-input-ok');
          formInput.classList.remove('c-input-error');
        } else if (field.type == 'text') {
          validateTextInput(field);
        } else if (field.type == 'email') {
          validateEmailInput(field);
        } else if (field.type == 'tel') {
          validateTelInput(field);
        } else if (field.type == 'password') {
          validatePasswordInput(field);
          // } else if (field.type == 'radio') {
          //     validateRadioInput(field);
          // } else if (field.type == 'checkbox') {
          //     validateCheckboxtInput(field);
        } else if (field.tagName == 'SELECT') {
          validateSelectInput(field);
        } else if (field.tagName == 'TEXTAREA') {
          validateTextareaInput(field);
        }
      }
    }
  });
}

function validateTextInput(field) {
  var formInput = field.closest('.c-form-row, .c-form__field');
  var blankError = formInput.querySelector('.error' + field.getAttribute('id'));
  if (field.value === '') {
    formInput.classList.add('c-input-error');
    formInput.classList.remove('c-input-ok');
    if (blankError != null) {
      blankError.classList.add('u-display-block');
      blankError.classList.remove('u-display-none');
    }
  } else {
    formInput.classList.add('c-input-ok');
    formInput.classList.remove('c-input-error');
    if (blankError != null) {
      blankError.classList.add('u-display-none');
      blankError.classList.remove('u-display-block');
    }
  }
}

function validateEmailInput(field) {
  var formInput = field.closest('.c-form-row, .c-form__field');
  var blankError = formInput.querySelector('.error' + field.getAttribute('id'));
  var invalidError = formInput.querySelector(
    '.errorValid' + field.getAttribute('id')
  );
  if (field.value === '') {
    formInput.classList.add('c-input-error');
    formInput.classList.remove('c-input-ok');
    if (blankError != null) {
      blankError.classList.add('u-display-block');
      blankError.classList.remove('u-display-none');
    }
    if (invalidError != null) {
      invalidError.classList.add('u-display-none');
      invalidError.classList.remove('u-display-block');
    }
  } else {
    if (blankError != null) {
      blankError.classList.add('u-display-none');
      blankError.classList.remove('u-display-block');
    }
    // var emailRegex = this.dataset.pattern;
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!field.value.match(emailRegex)) {
      formInput.classList.add('c-input-error');
      formInput.classList.remove('c-input-ok');
      if (invalidError != null) {
        invalidError.classList.add('u-display-block');
        invalidError.classList.remove('u-display-none');
      }
    } else {
      formInput.classList.add('c-input-ok');
      formInput.classList.remove('c-input-error');
      if (invalidError != null) {
        invalidError.classList.add('u-display-none');
        invalidError.classList.remove('u-display-block');
      }
    }
  }
}

function validateTelInput(field) {
  var formInput = field.closest('.c-form-row, .c-form__field');
  var blankError = formInput.querySelector('.error' + field.getAttribute('id'));
  var invalidError = formInput.querySelector(
    '.errorValid' + field.getAttribute('id')
  );
  if (field.value === '') {
    formInput.classList.add('c-input-error');
    formInput.classList.remove('c-input-ok');
    if (blankError) {
      blankError.classList.add('u-display-block');
      blankError.classList.remove('u-display-none');
    }
    if (invalidError) {
      invalidError.classList.add('u-display-none');
      invalidError.classList.remove('u-display-block');
    }
  } else {
    if (blankError) {
      blankError.classList.add('u-display-none');
      blankError.classList.remove('u-display-block');
    }
    // var phoneRegex = this.dataset.pattern;
    var phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
    if (!field.value.match(phoneRegex)) {
      formInput.classList.add('c-input-error');
      formInput.classList.remove('c-input-ok');
      if (invalidError != null) {
        invalidError.classList.add('u-display-block');
        invalidError.classList.remove('u-display-none');
      }
    } else {
      formInput.classList.add('c-input-ok');
      formInput.classList.remove('c-input-error');
      if (invalidError != null) {
        invalidError.classList.add('u-display-none');
        invalidError.classList.remove('u-display-block');
      }
    }
  }
}

function passwordHelpText(form) {
  var passwordInput = form.querySelector('input#Password');
  var confirmPasswordInput = form.querySelector('input#ConfirmPassword');
  if (typeof confirmPasswordInput != null && confirmPasswordInput != null) {
    var helpText = passwordInput
      .closest('.c-form__field')
      .querySelector('.m-helptext');
    if (helpText != null) {
      var excludeLanguages = ['zh-cn', 'ja', 'ko', 'ru', 'tw'];
      if (
        excludeLanguages.indexOf(
          document.querySelector('html').getAttribute('lang')
        ) === -1
      ) {
        var criteriaArray = helpText.innerText.trim().match(/([^\[\]])+/g);
        helpText.innerHTML =
          '<strong>' +
          criteriaArray[0] +
          "</strong><ul><li class='eightChar'>" +
          criteriaArray[1] +
          "</li><li class='upperCase'>" +
          criteriaArray[2] +
          "</li><li class='lowerCase'>" +
          criteriaArray[3] +
          "</li><li class='number'>" +
          criteriaArray[4] +
          "</li><li class='space'>" +
          criteriaArray[5] +
          '</li></ul>';
        passwordInput.addEventListener('keyup', function () {
          if (passwordInput.value.length >= 8) {
            helpText.querySelector('.eightChar').classList.add('done');
          } else {
            helpText.querySelector('.eightChar').classList.remove('done');
          }
          if (/.*[A-Z]+.*/.test(passwordInput.value)) {
            helpText.querySelector('.upperCase').classList.add('done');
          } else {
            helpText.querySelector('.upperCase').classList.remove('done');
          }
          if (/.*[a-z]+.*/.test(passwordInput.value)) {
            helpText.querySelector('.lowerCase').classList.add('done');
          } else {
            helpText.querySelector('.lowerCase').classList.remove('done');
          }
          if (/.*[0-9]+.*/.test(passwordInput.value)) {
            helpText.querySelector('.number').classList.add('done');
          } else {
            helpText.querySelector('.number').classList.remove('done');
          }
          if (/.* +.*/.test(passwordInput.value)) {
            helpText.querySelector('.space').classList.remove('done');
          } else {
            helpText.querySelector('.space').classList.add('done');
          }
        });
        passwordInput.addEventListener('focus', function () {
          helpText.classList.remove('u-display-none');
          helpText.style.zIndex = '1';
        });
        passwordInput.addEventListener('blur', function () {
          helpText.classList.add('u-display-none');
        });
      } else {
        helpText.remove();
      }
    }
  }
}

function validatePasswordInput(field) {
  var formInput = field.closest('.c-form-row, .c-form__field');
  var blankError = formInput.querySelector('.error' + field.getAttribute('id'));
  var invalidError = formInput.querySelector(
    '.errorValid' + field.getAttribute('id')
  );
  if (field.value === '') {
    formInput.classList.add('c-input-error');
    formInput.classList.remove('c-input-ok');
    if (blankError) {
      blankError.classList.add('u-display-block');
      blankError.classList.remove('u-display-none');
    }
  } else {
    if (blankError) {
      blankError.classList.add('u-display-none');
      blankError.classList.remove('u-display-block');
    }
    if (field.id === 'Password') {
      if (
        field.value.length >= 8 &&
        /.*[A-Z]+.*/.test(field.value) &&
        /.*[a-z]+.*/.test(field.value) &&
        /.*[0-9]+.*/.test(field.value) &&
        !/.* +.*/.test(field.value)
      ) {
        formInput.classList.add('c-input-ok');
        formInput.classList.remove('c-input-error');
        if (invalidError) {
          invalidError.classList.add('u-display-none');
          invalidError.classList.remove('u-display-block');
        }
      } else {
        formInput.classList.add('c-input-error');
        formInput.classList.remove('c-input-ok');
        if (invalidError) {
          invalidError.classList.add('u-display-block');
          invalidError.classList.remove('u-display-none');
        }
      }
    } else if (field.id === 'ConfirmPassword') {
      if (
        field.value ==
          formInput.closest('form').querySelector('#Password').value &&
        field.value.length >= 8 &&
        /.*[A-Z]+.*/.test(field.value) &&
        /.*[a-z]+.*/.test(field.value) &&
        /.*[0-9]+.*/.test(field.value) &&
        !/.* +.*/.test(field.value)
      ) {
        formInput.classList.add('c-input-ok');
        formInput.classList.remove('c-input-error');
        if (invalidError) {
          invalidError.classList.add('u-display-none');
          invalidError.classList.remove('u-display-block');
        }
      } else {
        formInput.classList.add('c-input-error');
        formInput.classList.remove('c-input-ok');
        if (invalidError) {
          invalidError.classList.add('u-display-block');
          invalidError.classList.remove('u-display-none');
        }
      }
    }
  }
}

// function validateRadioInput(field) {
// }

// function validateCheckboxInput(field) {
// }

function validateSelectInput(field) {
  var formInput = field.closest('.c-form-row, .c-form__field');
  var blankError = formInput.querySelector('.error' + field.getAttribute('id'));
  if (field.value === '') {
    formInput.classList.add('c-input-error');
    formInput.classList.remove('c-input-ok');
    if (blankError) {
      blankError.classList.add('u-display-block');
      blankError.classList.remove('u-display-none');
    }
  } else {
    formInput.classList.add('c-input-ok');
    formInput.classList.remove('c-input-error');
    if (blankError) {
      blankError.classList.add('u-display-none');
      blankError.classList.remove('u-display-block');
    }
  }
}

function validateTextareaInput(field) {
  var formInput = field.closest('.c-form-row, .c-form__field');
  var blankError = field.nextElementSibling.querySelector(
    '.error' + field.getAttribute('id')
  );
  if (field.value === '') {
    formInput.classList.add('c-input-error');
    formInput.classList.remove('c-input-ok');
    if (blankError) {
      blankError.classList.add('u-display-block');
      blankError.classList.remove('u-display-none');
    }
  } else {
    formInput.classList.add('c-input-ok');
    formInput.classList.remove('c-input-error');
    if (blankError) {
      blankError.classList.add('u-display-none');
      blankError.classList.remove('u-display-block');
    }
  }
}
